export function Info() {
  return (
    <main className="info-page container">
      <title>Vilkår og kontakt — Originalene</title>
      <meta name="description" content="Vilkår for bruk av Originalene, og kontaktinformasjon til SAU Torp Tjenester." />
      <h1>Vilkår &amp; Kontakt</h1>

      <section id="vilkar">
        <h2>Vilkår for bruk</h2>

        <p>
          Originalene er en nettmarkedsplass som formidler salg av originalkunst direkte
          mellom kunstnere og kjøpere. Ved å bruke tjenesten godtar du disse vilkårene.
        </p>

        <h2>Kunstnerens ansvar</h2>

        <p>
          Kunstnere som registrerer seg på Originalene er selv ansvarlige for at opplastet
          innhold ikke krenker tredjeparts opphavsrett, og at innholdet er lovlig å selge
          i Norge. Originalene forbeholder seg retten til å fjerne innhold som bryter
          gjeldende retningslinjer eller norsk lov, uten varsel.
        </p>

        <h2>Provisjon og betaling</h2>

        <p>
          Originalene tar en provisjon på 10&nbsp;% av salgsprisen per transaksjon.
          Resterende 90&nbsp;% overføres direkte til kunstnerens Stripe-konto.
          Alle betalinger behandles av Stripe. Kjøper ledes til Stripes betalingsside
          for å gjennomføre kjøpet. Originalene lagrer ikke betalingsinformasjon.
        </p>

        <h2>Ansvarsfraskrivelse</h2>

        <p>
          Originalene er en teknisk plattform og er ikke part i kjøpsavtalen mellom
          kjøper og kunstner. Eventuelle tvister om leveranse, kvalitet eller retur
          må løses direkte mellom partene. Tjenesten leveres «som den er» uten
          garantier for tilgjengelighet eller feilfrihet.
        </p>

        <h2>Endringer i vilkårene</h2>

        <p>
          Originalene kan endre disse vilkårene med rimelig varsel. Fortsatt bruk av
          tjenesten etter at endringer er publisert regnes som aksept av de nye vilkårene.
        </p>
      </section>

      <section id="kontakt">
        <h2>Kontakt</h2>

        <p>
          SAU Torp Tjenester<br />
          Org.nr. 934 067 894<br />
          E-post:{' '}
          <a href="mailto:kontakt@originalene.no">
            kontakt@originalene.no
          </a>
        </p>

        <p>
          For spørsmål om kjøp, salg eller tekniske problemer — ta gjerne kontakt
          på e-postadressen over.
        </p>
      </section>
    </main>
  )
}
